<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-input
            @input.native="onGroupsSearch"
            v-model="search"
            class="input--200"
            type="search"
            placeholder="Search by group name"
            name="search"
        />
      </app-cells>
      <div v-for="safari_table_item of safari_table" :key="safari_table_item.name" class="safari-block">
        <app-cells>
          <h2 class="title">{{ safari_table_item.name }}</h2>
          <div v-if="safari_table_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
        </app-cells>
        <v-client-table
            :data="safari_table_item.items"
            :columns="table.columns"
            :options="table.options"
            class="table-default"
            :class="{ 'table-default--loading': table_preloader }"
        >
          <template #h__name>
            <div class="table-default__left">Name</div>
          </template>
          <template #h__orders>Orders<br>available</template>
          <template #h__summary_printed>Summary<br>printed</template>
          <template #h__packing_started>Packing<br>started</template>
          <template #h__requests>Orders<br>to collect</template>
          <template #h__requests_need_payment>Orders<br>unpaid</template>
          <template #h__driver>Passed<br>to driver</template>
          <template #h__start_from><div class="table-default__left">Start from</div></template>
          <template #name="{ row }">
            <div class="table-default__left">
              <router-link
                  :to="{ name: 'safari-groups-detail-snacks', params: { id: row.id } }"
                  class="table-default__link-border"
              >
                {{ row.name }}
              </router-link>
            </div>
          </template>
          <template #type="{ row }">
            <span class="status-tag" :style="{ 'backgroundColor': row.type.color || '#8a8a8a' }">
              {{ row.type ? row.type.name : '-' }}
            </span>
          </template>
          <template #orders="{ row }">
            <span class="status-tag" :style="{ 'backgroundColor': row.snack_bar.info.orders_available ? '#77b017' : '#5f5f5f' }">
              {{ row.snack_bar.info.orders_available ? 'Yes' : 'No' }}
            </span>
          </template>
          <template #summary_printed="{ row }">
            <span class="status-tag" :style="{ 'backgroundColor': row.snack_bar.info.summary_printed ? '#77b017' : '#f0c427' }">
              {{ row.snack_bar.info.summary_printed ? 'Yes' : 'No' }}
            </span>
          </template>
          <template #packing_started="{ row }">
            <span class="status-tag" :style="{ 'backgroundColor': row.snack_bar.info.packing_started ? '#77b017' : '#f0c427' }">
              {{ row.snack_bar.info.packing_started ? 'Yes' : 'No' }}
            </span>
          </template>
          <template #requests="{ row }">
            <span
                class="status-tag"
                :style="{ 'backgroundColor': row.snack_bar.orders.collected === row.snack_bar.orders.to_be_collected ? '#77b017' : '#f0c427' }"
            >
              {{ row.snack_bar.orders.collected }} / {{ row.snack_bar.orders.to_be_collected }}
            </span>
          </template>
          <template #requests_need_payment="{ row }">
            <span
              class="status-tag"
              :style="{ 'backgroundColor': !row.snack_bar.orders.need_payment ? '#5f5f5f' : '#e85c20' }"
            >
              {{ row.snack_bar.orders.need_payment }}
            </span>
          </template>
          <template #collected="{ row }">
            <span
              class="status-tag"
              :style="{ 'backgroundColor': row.snack_bar.info.collected ? '#77b017' : '#f0c427' }"
            >
              {{ row.snack_bar.info.collected ? 'Yes' : 'No' }}
            </span>
          </template>
          <template #driver="{ row }">
            <span class="status-tag" :style="{ 'backgroundColor': row.snack_bar.info.passed_to_driver ? '#77b017' : '#f0c427' }">
              {{ row.snack_bar.info.passed_to_driver ? 'Yes' : 'No' }}
            </span>
          </template>
          <template #number_of_clients="{ row }">
          <span
              v-tooltip="{ content: clientTableList(row.clients), placement: 'top-start', offset: 10, html: true }"
              :style="{cursor: 'pointer'}"
          >
            {{ row.number_of_clients }}
          </span>
          </template>
          <template #tour_start="{ row }">
            {{ dateFormatTable(row.tour_start) }}
          </template>
          <template #tour_end="{ row }">
            {{ dateFormatTable(row.tour_end) }}
          </template>
          <template #start_from="{ row }">
            <div class="table-default__left">{{ row.start_from?.short_name || '-' }}</div>
          </template>
        </v-client-table>
      </div>
      <app-cells position="between">
        <div>
          <paginate
              :clickHandler="onClickPagination"
              v-if="pagination.pages > 1"
              v-model="pagination.page"
              :page-count="pagination.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table_length" :page="pagination.page" :limit="40" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getSafariGroupsByDates } from '@/http'
import debounce from 'lodash/debounce'
import { format, parse } from 'date-fns'

export default {
  name: 'SafariSnackBarInTourList',
  data() {
    return {
      is_loaded: false,
      search: null,
      safari_table: [],
      table_length: 0,
      table: {
        items: [],
        columns: [
          'name',
          'number_of_clients',
          'cars_required',
          'type',
          'orders',
          'summary_printed',
          'packing_started',
          'requests',
          'requests_need_payment',
          'collected',
          'driver',
          'tour_start',
          'tour_end',
          'start_from'
        ],
        options: {
          headings: {
            'name': 'Name',
            'number_of_clients': 'Pax',
            'cars_required': 'Cars',
            'type': 'Type',
            'orders': 'Orders available',
            'summary_printed': 'Summary printed',
            'packing_started': 'Packing started',
            'requests': 'Orders to collect',
            'requests_need_payment': 'Orders unpaid',
            'collected': 'Collected',
            'driver': 'Passed to driver',
            'tour_start': 'Start',
            'tour_end': 'Finish',
            'start_from': 'Start from',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    clientTableList(clients) {
      let result = ''
      for (const key in clients) {
        result += `${clients[key].first_name} ${clients[key].last_name}<br>`
      }
      return result
    },
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : ''
    },
    dateFormatTable(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM') : '-'
    },
    fetchItems() {
      const params = {
        page: this.pagination.page,
        page_size: 40,
        search: this.search,
        category: 'in_tour',
        group_by: 'tour_end',
        ordering: 'tour_end',
        range_type: 'day',
        type_exclude: 'gamepackage'
      }
      getSafariGroupsByDates(params)
        .then(res => {
          this.safari_table = res.data.results
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count
          this.table_length = 0
          res.data.results.forEach(item => {
            this.table_length += item.items.length
          })
          this.is_loaded = true
          this.table_preloader = false
        })
    },
    onGroupsSearch() {
      this.table_preloader = true
      this.searchGroups(this)
    },
    searchGroups: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
  }
}
</script>

<style lang="sass" scoped>
.safari-block
  margin-bottom: 30px
</style>
